export default {
  zh: {
    plaza: 'CP',
    rank: '排行榜',
    reward: '奖励',
    week: '本周排行',
    title: 'CP互相赠送礼物（超过1800金币）会展示在cp广场',
    last: '上周排行',
    previous: '以往CP第一名',
    remark: '发送礼物"求婚",就可以成为cp,只有互相赠送cp礼物才会增加cp积分',
    cp: '是否取消CP（取消后所有积分清零）',
    cancel: '取消',
    confirm: '确定',
    clear: '取消',
    totalScore: '总积分（不仅是这周）',
    service: '如果有疑问，点击这里联系客服',
    rewardtitle: '规则',
    rule: 'Rules',
    rewardRule: `
    - 关于头像框和座驾：可以从用户获胜的任何位置拿走头像框和座驾<br/><br/>
    - 关于徽章：徽章只能在完成用户获胜中心的积分的情况下获得，不能兑换其他中心的任何徽章<br/><br/>
    - 关于金币：如果用户赢了其中一个名次，比如（某用户赢了第一名，但是他的积分只有500k，意味着小于800k。在这种情况下，他将获得第一名头像框+第一名座驾+第一名徽章+第二名的金币，因为他满足了超过400k的第二名的金币条件）<br/><br/>
    但是如果第一名的积分小于500k，比如只有400k，那意味着比获得第一名的徽章的条件还低，在这种情况下，他将只获得第一名的头像框和座驾，没有徽章奖励。
    <br/>其他礼物不会影响您的CP分数，只有CP礼物可以提高您的活动分数`,
    yy: '为了庆祝情人节，在活动期间,赠送情人节特别礼物（ run to you），也可以成为cp，这周前三名将会有额外奖励，祝大家情人节快乐 。',
    provetomeyourlove: "اثبت حبك لي",
    prize: "Prize",
    bless:"Bless",
  },
  ar: {
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    clear: 'يلغي',
    rule: 'القواعد',
    rewardtitle: 'حكم',
    successful: "العملية كانت ناجحه",
    rewardRule: `<br/>شارك حبك مع كل الناس، لنحتفل بعيد الحب في تشاتي
    <br/> ١- يمكن لجميع المستخدمين ارسال بطائق حب لعشيقهم،بعد نجاح إرسال البطاقة ستظهر في قأئمة الحدث 
    <br/> ٢- يمكن ارسال اكثر من بطاقة لاكثر من عشيق، ولكن ستظهر اخر رساله فقط في القائمة 
    <br/> ٣- اكثر خمسة عشاق حصلوا على عدد تهاني سيتم تكريمهم بالظهور في شجرة الحب والحصول على جوائز الحدث( الحد الادنى للظهور في الشجرة هي 1000 تهنئة) 
    ٤- يمكن للجمهور ايضا الحصول على جوائز من خلال ارسال التهاني لإصدقائهم في قائمة الحدث`,
    provetomeyourlove: "اثبت حبك لي",
    prize: "الجوائز",
    sendaLoveCard:'ارسل بطاقة حب',
    bless:"تهنئة",
    blessOne:"تهنئة مره",
    blessTwo:"5 مرات",
    blessThree:"10 مرات",
    to:"الى:",
    from:"من:",
    donnothadCp:"ليس لديك عشيق مرتبط بك، اذهب لصفحة السي بي للإرتباط",
    nocpTip:"يجب عليك إرسال الهدايا المخصصة لربط السي بي قبل أن تتمكن من المشاركة في هذا الحدث",
    okText:"نعم",
    timeR: 'العد التنازلي',
    days: 'أيام',
    payText:"انفق",
    sendNum:"2000 للإرسال ياقوته",
    saysomethingtoyourlover:"قل شيئا لحبيبك",
    pleaseentertextfirst:"قم بإدخال النص اولا",
    fifty:"50 كوينزه",
    hundredGold:"100 كوينزه",
    hundredRuby:"100 ياقوته",  
    voting:"جوائز التصويت",
  },
  en: {
    successful: "The operation was successful",
    cancel: 'Cancel',
    confirm: 'Confirm',
    clear: 'Cancel',
    rule: 'Rules',
    rewardtitle: 'Rules',
    rewardRule: `Share the love with all people, let's celebrate App Valentine's Day<br/>
    1. All users can send Love Card to their CP. After each Love Card is successfully sent, it will be displayed on the event page.<br/>
    2. Each user can send Love Cards to multiple CPs, but for the same pair of CPs, we will only retain the latest Love Card.<br/>
    3. The top 5 CP pairs that receive the most blessings will have the opportunity to climb the TREE OF LOVE and receive rewards at the same time.(clime the Tree need to receive  at least 1000 blessing )<br/>
    4. users can also get rewards by sending more blessings to there friends `,
    provetomeyourlove: "PROVE TO ME YOUR LOVE",
    prize: "Prize",
    sendaLoveCard:'Send a Love Card',
    bless:"Bless",
    blessOne:"Bless 1 Time",
    blessTwo:"Bless 5 Times",
    blessThree:"Bless 10 Times",
    to:"To:",
    from:"From:",
    donnothadCp:"You haven't bound CP yet",
    nocpTip:"You need to send a proposal gift to bind CP before you can participate in this event",
    okText:"OK",
    timeR: 'Count down: ',
    days: 'days',
    payText:"Pay",
    sendNum:"2000 and Send",
    saysomethingtoyourlover:"say something to your lover",
    pleaseentertextfirst:"Please enter text first.",
    fifty:"50 Coins",
    hundredGold:"100 Coins",
    hundredRuby:"100 Rubies",  
    voting:"Voting Rewards",
  },
  tr: {
    rule: 'Kural',
    cancel: 'İptal',
    confirm: 'Onayla',
    clear: 'Ayrıl',
    successful: "İşlem Başarılı Oldu",
    rewardtitle: 'Kurallar',
    rewardRule: `
    - Çerçeve ve Araç: Kullanıcı hangi Sıralamayı kazanırsa kazansın, bir çerçeve ve bir Araç alabilir.<br/><br/>
    - Rozet: Rozet, Yalnızca kullanıcının kazandığı sıralamanın puanlarının tamamlanması durumunda alınabilir ve başka bir rozetle değiştirilemez.<br/><br/>
    - Altın Desteği: Kullanıcının sıralamadan birini kazanması durumunda, örneğin (bir kullanıcı ilk sırayı kazandı, ancak puanları, örneğin 500K, Altın desteği almak için gereken 800K’dan az anlamına gelir, bu durumda birincilik Çerçevesi + birincilik Araç + birincilik rozeti + 400 binden fazla olan ikinci sıra Altın desteği koşulunu karşıladığı için ikincilik ödülleri alabilir).<br/><br/>
    Ancak ilk sırada 500K daha az puanla birinci olması durumunda, örneğin 400K, ilk rozetin puanlarından bile daha az anlamına gelir, bu durumda, sadece birincilik ve ikincilik için çerçeveyi ve Araç alacak, bu da rozetsiz ödüller anlamına gelir.
    <br/>Diğer hediyeler CP puanınızı etkilemez, yalnızca CP hediyeleri Cp Etkinliği puanınızı artırabilir.`,
    provetomeyourlove: "HERKESE AŞKINIZI KANITLAYIN",
    prize: "Ödül",
    sendaLoveCard:'Aşk Kartı Gönder',
    bless:"Kutsama",
    blessOne:"1 Kez Kutsa",
    blessTwo:"5 Kez Kutsa",
    blessThree:"10 Kez Kutsa",
    to:"Kime: ",
    from:"Kimden: ",
    donnothadCp:"Henüz CP bağlantısı oluşturmadınız",
    nocpTip:"Bu etkinliğe katılabilmeniz için önce CP  bağlantısı için bir cp teklifi hediyesi göndermeniz gerekmektedir.",
    okText:"TAMAM",
    timeR: 'Kalan süre: ',
    days: 'gün',
    payText:"Öde",
    sendNum:"2000 Öde ve Gönder",
    saysomethingtoyourlover:"Sevgiline Bir Şeyler Söyle",
    pleaseentertextfirst:"Lütfen önce metni gitin.",
    fifty:"50 Altın",
    hundredGold:"100 Altın",
    hundredRuby:"100 Yakut",
    voting:"Oylama Ödülleri",
  },
}



// WEBPACK FOOTER //
// src/pages/activity/valentineDay/thumbsUp/lang.js